module.exports = __webpack_public_path__ + "img/default_finished.5c21bd62.png";